var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-wrapper"},[_c('img',{staticClass:"logo",attrs:{"src":"images/logo.png"}}),_c('div',{staticClass:"tagline"})])}]

export { render, staticRenderFns }